import { defineComponent as _defineComponent } from 'vue'
import useCommonMixin from '@/composables/useCommonMixin'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import { computed, onMounted, ref } from 'vue'
  import UsersApi from '@/services/api/UsersApi'
  import { useRoute, useRouter } from 'vue-router/composables'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import eventBus from '@/main'
  import useI18n from '@/composables/useI18n'
  import { useVuelidate } from '@vuelidate/core'
  import type { ValidationArgs } from '@vuelidate/core'
  import { required, email } from '@vuelidate/validators'
  import CommonApi from '@/services/api/CommonApi'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SetPrimaryEmail',
  setup(__props) {

  const route = useRoute()
  const router = useRouter()

  const form = ref({
    email: '',
  } as { [key: string]: string })
  const confirmationToken = ref('')
  const settingUpAccount = ref(false)

  const validation: ValidationArgs<any> = {
    email: {
      required,
      email,
    },
  }

  const $v: any = useVuelidate(validation, form.value)

  const emailErrors = computed((): string[] => {
    const errors: string[] = []
    if (!$v.value.email.$dirty) return errors
    if ($v.value.email.required.$invalid) errors.push(translateString('onboarding.errors.requiredField'))
    else if ($v.value.email.email.$invalid) errors.push(translateString('onboarding.errors.invalidEmail'))

    return errors
  })

  const pendingOrderId = computed(() => route.params.pendingOrderId)

  const { desktopLogo } = useCommonMixin()
  const { translateString } = useI18n()

  const routeToHomepage = () => router.push('/')

  const setPrimaryEmailAndCompleteOrder = () => {
    if (!pendingOrderId.value && !form.value.email && !confirmationToken.value) return
    settingUpAccount.value = true
    UsersApi.completePendingOrder(pendingOrderId.value, form.value.email, confirmationToken.value)
      .then(() => {
        settingUpAccount.value = false
        eventBus.$toasted.success(translateString('onboarding.accountCreated'))

        setTimeout(() => {
          window.location.href = '/'
        }, 1500)
      })
      .catch((error) => {
        if (error.response && typeof error.response.status === 'number') {
          eventBus.$toasted.error(translateString('onboarding.errors.couldNotCompleteOrder'), {
            duration: 5000,
          })
          CommonApi.postSlackMessage(
            `Could not complete order.\nPending Order ID: ${pendingOrderId.value}\nEmail Submitted: ${form.value.email}\nResponse: ${error.response.data}`,
          )
        }
      })
  }

  const fetchPendingOrder = () => {
    if (!pendingOrderId.value) return
    UsersApi.getPendingOrder(pendingOrderId.value)
      .then((resp) => {
        if (!resp.active) {
          eventBus.$toasted.info(translateString('onboarding.primaryEmailAlreadySet'))
          routeToHomepage()
          return
        }
        form.value.email = resp.email
        confirmationToken.value = resp.confirmationToken
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          routeToHomepage()
        }
      })
  }

  fetchPendingOrder()

  onMounted(() => {
    if (!pendingOrderId.value) routeToHomepage()
  })

return { __sfc: true,route, router, form, confirmationToken, settingUpAccount, validation, $v, emailErrors, pendingOrderId, desktopLogo, translateString, routeToHomepage, setPrimaryEmailAndCompleteOrder, fetchPendingOrder, useCommonMixin, KetchUpButton, computed, onMounted, ref, UsersApi, useRoute, useRouter, LoadingSpinner, eventBus, useI18n, useVuelidate, required, email, CommonApi }
}

})